module.exports = __webpack_public_path__ + "static/img/50成都环保.9e4357d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/50成都环保.jpg
// module id = 8BUO
// module chunks = 0